export default "__VITE_ASSET__DLW2sc9U__"